(() => {
  if (customElements.get('nb-reviews')) return;
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  class Reviews extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('[data-review-data]');
      const content = this.querySelector('[data-review-content]');
      if (!content || (!source && !this.dataset.source)) return;
      let data;
      try {
        data = this.dataset.source
          ? await window.NextBottleReviews.load(this.dataset.source, this.dataset.productId)
          : JSON.parse(source.textContent);
      } catch { content.textContent = 'Bewertungen derzeit nicht verfügbar. Bitte lade die Seite erneut.'; return; }
      if (String(data.product_id) !== this.dataset.productId || !Array.isArray(data.reviews)) return;
      // Reject the whole projection on invalid records; never silently change totals.
      if (data.reviews.some(r => !r || !Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5 ||
        ['id','title','body','author','date','reply'].some(k => typeof r[k] !== 'string') ||
        !/^\d{4}-\d{2}-\d{2}$/.test(r.date) || !Array.isArray(r.images))) return;
      if (new Set(data.reviews.map(r => r.id)).size !== data.reviews.length) return;
      this.initialized = true;
      content.replaceChildren();
      this.rows = data.reviews;
      const count = this.rows.length;
      if (!count) {
        const empty = node('p', 'Für dieses Produkt gibt es noch keine Bewertungen.');
        empty.setAttribute('role', 'status');
        content.append(empty);
        return;
      }
      const avg = count ? (this.rows.reduce((sum,r) => sum+r.rating,0)/count).toLocaleString('de-DE',{maximumFractionDigits:2}) : '–';
      content.append(node('p', `${avg} von 5 · ${count} ${count === 1 ? 'Bewertung' : 'Bewertungen'}`));
      const controls = node('div', undefined, 'nb-review-controls');
      this.stars = this.select(controls, 'Sterne', [['all','Alle Bewertungen'],...[5,4,3,2,1].map(n => [String(n),`${n} ${n===1?'Stern':'Sterne'}`])]);
      this.order = this.select(controls, 'Sortierung', [['new','Neueste zuerst'],['old','Älteste zuerst'],['high','Beste zuerst'],['low','Kritischste zuerst']]);
      this.status = node('p'); this.status.setAttribute('role','status');
      this.grid = node('div', undefined, 'nb-review-grid');
      this.more = node('button','Weitere Bewertungen anzeigen'); this.more.type='button'; this.more.dataset.more='';
      this.more.addEventListener('click',() => this.update(false));
      content.append(controls,this.status,this.grid,this.more);
      this.update(true);
    }
    select(parent, caption, options) {
      const label=node('label',caption), select=node('select');
      for(const [value,text] of options){const option=node('option',text);option.value=value;select.append(option);}
      label.append(select);parent.append(label);select.addEventListener('change',()=>this.update(true));return select;
    }
    update(reset) {
      const rows=this.rows.filter(r => this.stars.value==='all' || r.rating===Number(this.stars.value));
      rows.sort((a,b) => this.order.value==='high' ? b.rating-a.rating || b.date.localeCompare(a.date) : this.order.value==='low' ? a.rating-b.rating || b.date.localeCompare(a.date) : this.order.value==='old' ? a.date.localeCompare(b.date) : b.date.localeCompare(a.date));
      if(reset){this.shown=0;this.grid.replaceChildren();}
      const next=rows.slice(this.shown,this.shown+10);
      for(const review of next)this.grid.append(this.card(review));
      this.shown+=next.length;
      this.status.textContent=rows.length ? `${this.shown} von ${rows.length} Bewertungen angezeigt` : 'Keine Bewertungen mit dieser Sternezahl vorhanden.';
      this.more.hidden=this.shown>=rows.length;
      if(!reset && this.more.hidden){this.status.tabIndex=-1;this.status.focus();}
    }
    card(review) {
      const card=node('article');
      const stars=node('span','★'.repeat(review.rating)+'☆'.repeat(5-review.rating),'nb-review-stars');stars.setAttribute('aria-hidden','true');
      const rating=node('div');rating.setAttribute('role','img');rating.setAttribute('aria-label',`${review.rating} von 5 Sternen`);rating.append(stars);
      const meta=node('p',(review.author.trim().split(/\s+/)[0] || 'Anonym')+' · ','nb-review-meta'), time=node('time',review.date.split('-').reverse().join('.'));time.dateTime=review.date;meta.append(time);
      card.append(rating);
      if(review.title) card.append(node('h3',review.title));
      card.append(meta,node('p',review.body));
      const photos=node('div',undefined,'nb-review-photos');
      for(const media of review.images){
        if(!media || typeof media.file!=='string')continue;
        let url;try{url=new URL(media.file,document.baseURI);}catch{continue;}
        // Local preview images or uploaded Shopify files; no dependency on Judge.me.
        if(!((url.origin===location.origin && ['http:','https:'].includes(url.protocol)) || (url.protocol==='https:' && url.hostname==='cdn.shopify.com')))continue;
        const link=node('a');link.href=url.href;link.setAttribute('aria-label','Kundenfoto vergrößern');
        const image=node('img');image.src=url.href;image.alt='Kundenfoto zur Bewertung';image.loading='lazy';image.width=120;image.height=140;
        link.append(image);photos.append(link);
      }
      card.append(photos);
      if(review.reply){const reply=node('aside');reply.append(node('strong','Antwort von NextBottle'),node('p',review.reply));card.append(reply);}
      return card;
    }
  }
  customElements.define('nb-reviews',Reviews);
})();
